import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import { useDispatch } from "react-redux";
import { setUserData } from "../../../core/redux/action";
import apiHandler from "../../common/api";
import {
  fetchLocationDetails,
  fetchPublicIP,
  getDeviceType,
  setCookie,
} from "../../common/common";
// import { cryptoDecrypt } from "../../Crypto/Crypto.js";

const SigninThree = () => {
  const route = all_routes;
  const dispatch = useDispatch();
  const params = new URLSearchParams(window.location.search);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    businessId: "",
    deviceType: "",
    ipAddress: "",
    Type: "SignIn",
  });

  useEffect(() => {
    const user = params.get("user");
    const pwd = params.get("pwd");
    const email = params.get("email");
    if (user && pwd && email) {
      setFormData((prevState) => ({
        ...prevState,
        businessId: user,
        email: email,
        password: pwd,
        Type: "Default",
      }));
    }
  }, [params]);
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [rememberMe, setRememberMe] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    fetchPublicIP((error, ip) => {
      if (error) {
        console.error("Error fetching public IP:", error);
      } else {
        fetchLocationDetails(ip).then((location) => {
          if (location) {
            console.log("Location:", location);
            setFormData((prevState) => ({
              ...prevState,
              ipAddress: ip,
              country: location.country,
              region: location.region,
              city: location.city,
              zip: location.zip,
              latitude: location.latitude,
              longitude: location.longitude,
            }));
          }
        });
      }
    });

    const deviceType = getDeviceType();
    setFormData((prevState) => ({
      ...prevState,
      deviceType,
    }));
  }, []);

  const loginFunction = async () => {
    const errors = {};

    // Validate businessId email and password
    if (!formData.businessId) {
      errors.businessId = "Business Id is required.";
    }
    if (!formData.email) {
      errors.email = "Email is required.";
    }
    if (!formData.password) {
      errors.password = "Password is required.";
    }

    // If no errors, proceed with the login request
    if (Object.keys(errors).length === 0) {
      try {
        const response = await apiHandler({
          method: "POST",
          route: "/auth/login",
          payload: {
            email: formData.email,
            password: formData.password,
            businessUniqueName: formData.businessId,
            ipAddress: formData.ipAddress,
            deviceName: formData.deviceType,
          },
        });

        if (response.ResponseCode === "SUCCESS") {
          const userObject = {
            isLoggedIn: true,
            rememberMe,
            token: response.ResponseData.token,
            ...response.ResponseData.user,
          };

          // Store user data in a cookie for user management
          setCookie("u", userObject, { expires: 1 }); // Cookie expires in 1 days

          // Dispatch user data to Redux store
          dispatch(setUserData(userObject));

          // Redirect to the dashboard
          setTimeout(() => {
            if (formData.Type === "SignIn") {
              if (response.ResponseData.user.planIsActive != 1 && response.ResponseData.user.roleName != "Super Admin") {
                navigate("/businesssubscription");
              } else {
                navigate("/dashboard");
              }
            }

            if (formData.Type === "Default") {
              navigate("/businesssubscription");
            }
          }, 200);
        } else {
          errors.loginFailed = response.ResponseMessage;
          setFormErrors(errors);
        }
      } catch (error) {
        console.error("Login Error:", error);
        errors.loginFailed = "Invalid Credentials";
        setFormErrors(errors);
      }
    } else {
      // Handle validation errors
      setFormErrors(errors);
    }
  };

  console.log(formData, "formData<-------->");

  return (
    <div className="main-wrapper">
      <div className="account-content">
        <div className="login-wrapper login-new">
          <div className="container">
            <div className="login-content user-login">
              {/* <div>  className="login-logo"> */}
              <div style={{ marginBottom: "25px" }}>
                <ImageWithBasePath src="assets/img/BookYarra_logo_black.png" width={300} height={300} />
                <Link to={route.dashboard} className="login-logo logo-white">
                  <ImageWithBasePath src="assets/img/logo-white.png" alt width={300} height={300} />
                </Link>
              </div>
              <form>
                <div className="login-userset">
                  <div className="login-userheading">
                    <h3 className="primary-color">Sign In</h3>

                    <h4 className="text-color-70">
                      Access the BookYarra panel using your email and
                      Password.
                    </h4>
                  </div>
                  {formErrors.loginFailed && (
                    <span className="text-danger">
                      {formErrors.loginFailed}
                    </span>
                  )}
                  <div className="form-login">
                    <label className="text-color-70 form-label">
                      Business Unique Name / Username
                    </label>
                    <div className="form-addons">
                      <input
                        type="text"
                        name="businessId"
                        className="form-control"
                        value={formData.businessId}
                        onChange={handleInputChange}
                      />
                      <ImageWithBasePath
                        src="assets/img/icons/user-icon.svg"
                        alt="img"
                      />
                    </div>
                    {formErrors.businessId && (
                      <span className="text-danger">
                        {formErrors.businessId}
                      </span>
                    )}
                  </div>
                  <div className="form-login">
                    <label className="text-color-70 form-label">
                      Email Address
                    </label>
                    <div className="form-addons">
                      <input
                        type="text"
                        name="email"
                        className="form-control"
                        value={formData.email}
                        onChange={handleInputChange}
                      />
                      <ImageWithBasePath
                        src="assets/img/icons/mail.svg"
                        alt="img"
                      />
                    </div>
                    {formErrors.email && (
                      <span className="text-danger">{formErrors.email}</span>
                    )}
                  </div>
                  <div className="form-login">
                    <label className="text-color-70">Password</label>
                    <div className="pass-group">
                      <input
                        type={isPasswordVisible ? "text" : "password"}
                        name="password"
                        className="pass-input form-control"
                        value={formData.password}
                        onChange={handleInputChange}
                      />
                      <span
                        className={`fas toggle-password ${isPasswordVisible ? "fa-eye" : "fa-eye-slash"
                          }`}
                        onClick={togglePasswordVisibility}
                      ></span>
                    </div>
                    {formErrors.password && (
                      <span className="text-danger">{formErrors.password}</span>
                    )}
                  </div>
                  <div className="form-login authentication-check">
                    <div className="row">
                      <div className="col-6">
                        <div className="custom-control custom-checkbox">
                          <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                            <input
                              type="checkbox"
                              checked={rememberMe}
                              onChange={(e) => setRememberMe(e.target.checked)}
                            />
                            <span className="checkmarks" />
                            <span className="text-color-70">Remember me</span>
                          </label>
                        </div>
                      </div>
                      <div className="col-6 text-end">
                        <Link className="" to={route.forgotPasswordThree}>
                          Forgot Password?
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="form-login">
                    <Link
                      className="btn btn-login"
                      to="#"
                      onClick={() => loginFunction("SignIn")}
                    >
                      Sign In
                    </Link>
                  </div>
                  <div className="signinform text-center mt-3">
                    <h4 className="text-color-70">
                      Don&apos;t have a business account?
                      <a
                        href="https://bookyarra.com/business-registration"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ms-1 text-primary"
                      >
                        Register now
                      </a>
                    </h4>
                  </div>
                  {/* <div className="signinform">
                    <h4 className="text-color-70">
                      New on our platform?
                      <Link to={route.registerThree} className="text-color-70 hover-a">
                        {" "}
                        Sing up for Business Account
                      </Link>
                    </h4>
                  </div> */}
                  {/* <div className="form-setlogin or-text">
                    <h4>OR</h4>
                  </div>
                  <div className="form-sociallink">
                    <ul className="d-flex">
                      <li>
                        <Link to="#" className="facebook-logo">
                          <ImageWithBasePath
                            src="assets/img/icons/facebook-logo.svg"
                            alt="Facebook"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <ImageWithBasePath
                            src="assets/img/icons/google.png"
                            alt="Google"
                          />
                        </Link>
                      </li>
                      <li>
                        <Link to="#" className="apple-logo">
                          <ImageWithBasePath
                            src="assets/img/icons/apple-logo.svg"
                            alt="Apple"
                          />
                        </Link>
                      </li>
                    </ul>
                  </div> */}
                </div>
              </form>
            </div>
            <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
              <p>Copyright © 2023 BookYarra Pvt. All rights reserved</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SigninThree;
